import script from "./CreateOpportunityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOpportunityModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateOpportunityModal.vue?vue&type=style&index=0&id=6d2480b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2480b4"]])

export default __exports__